module.exports = __webpack_public_path__ + "img/219.2c114f21.png";